seedWebApp.controller('EditTokenCtrl', ['$scope', '$uibModal', 'TranslationService', '$uibModalInstance', 'CompanySettingService', 'ToastService',
    function ($scope, $uibModal, TranslationService, $uibModalInstance, CompanySettingService, ToastService) {

        //$scope.integrationID = integrationID;

        $scope.listItem = {};
        $scope.translation = TranslationService.getActiveTranslation();

        $scope.refresh = function () {
            $scope.error = false;
            $scope.loading = true;

            //console.log('refresh');
            CompanySettingService.getSettings().then(
                function (result) {
                    $scope.loading = false;
                    $scope.error = false;
                    $scope.listItem = result.data;
                    //console.log($scope.listItem);
                    //$scope.decodeSettings();
                    //$scope.checkModuleActiveToSelectHomePage();
                },
                function error(errorDescription) {
                    $scope.loading = false;
                    $scope.error = true;
                    $scope.errorDescription = errorDescription;
                });
        };

        $scope.refresh();

        $scope.generateAPIToken = function () {
            var createAPIToken = false;
            if ($scope.listItem.IntegrationAPIToken) {
                //var message = $scope.getTranslateText('ConfirmRegenerateAPIToken');
                var message = $scope.translation.ConfirmRegenerateAPIToken;
                if (confirm(message)) {
                    createAPIToken = true;
                }
            } else {
                createAPIToken = true;
            }
            if (createAPIToken) {
                CompanySettingService.generateAPIToken().then(
                    function (res) {
                        $scope.listItem.IntegrationAPIToken = res.data.IntegrationAPIToken;
                        $scope.listItem.TokenUpdateDate = res.data.TokenUpdateDate;
                    },
                    function (err) {
                        console.log('erro token')
                        console.log(err);
                    });
            }
        };

        $scope.copyCode = function () {
            var textarea = document.getElementById('integrationAPIToken');
            textarea.select();
            document.execCommand('copy');
            $scope.copied = true;

            setTimeout(function () {
                $scope.copied = false;
            }, 2000);
        };

        $scope.ok = function () {
            //debugger;

            console.log('save');
            console.log($scope.listItem);


            /*
            $scope.loading = true;
            IntegrationAdminService.save($scope.listItem, function (data) {
                IntegrationAdminService.resetCache();
                $uibModalInstance.close();
            }, function (error) {
                $scope.loading = false;
                console.log('erro salvar');
                console.log(error);
                ToastService.createToast('Erro ao salvar', error.statusText, 5000, 'error');
            });
            */
        };


        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }
]);
